<template>
    <main class="J-card-body m-b">
        <div class="J-card-item" v-for="(arraydataservice,index) in arraydataservices" :key="index">
            <div class="J-content-title">{{arraydataservice.name}}</div>
            <div class="J-theme-color-list">
                <div class="J-theme-color-item" v-for="(item,i) in arraydataservice.items" :key="i+1" :class="{'active':item.color==arraydataservice.color}" @click="selectedColor(item,arraydataservice,i)">
                    <div class="J-color-product"  :style="'background-color:'+item.color">

                    </div>
                    <div class="J-theme-color-amount" v-if="item.amount">
                        {{item.amount}}
                    </div>
                </div>
            </div>
            <div class="J-card-item-content J-card-item-content--color">
                
                <div class="J-color-image">
                    <div class="J-color-image-url"  @click="visualImg(arraydataservice.color_image)">
                      <img :src="arraydataservice.color_image?arraydataservice.color_image:$set(arraydataservice,'color_image',arraydataservice.image?arraydataservice.image[0]!=null?arraydataservice.image[0].link:'':'')" style="cursor:pointer" >
                    </div>
                </div>
            </div>
            <div>
               <div class="J-content-price" :class="{'inactive':arraydataservice.color_price}">S/. {{arraydataservice.color_price}}</div>
               <div class="J-content-price" v-if="arraydataservice.percentaje_x_mayor">S/. {{calcDiscounts(arraydataservice.color_price,arraydataservice.percentaje_x_mayor)}}</div>
                <div class="J-discounts" v-if="arraydataservice.percentaje_x_mayor">
                    -{{arraydataservice.percentaje_x_mayor}} %
                </div>
                <div class="J-content-description">{{arraydataservice.color_description}}</div>
                <div class="J-theme-color-talla">
                    <div class="J-theme-color-talla-item" v-for="(item,i) in arraydataservice.sizes" :key="i+1" :class="{'active':item==arraydataservice.size}" @click="activeSize(item,arraydataservice)">
                        {{item.size}}
                        <div class="J-theme-color-amount"  v-if="item.amount">
                            {{item.amount}}
                        </div>
                    </div>
                </div>
            </div>

            <div class="J-theme-color-add">
                <div class="J-list-price-minus" v-if="!view">
                    <button class="J-card-item-btn" @click="amountUnique(-1,index)"><i class="fas fa-minus"></i></button>
                </div>
                <div>
                   <span  v-if="arraydataservice.amount==undefined">{{$set(arraydataservice, 'amount', 0)}}</span>
                    <span  v-else-if="arraydataservice.amount!==0&&!view">
                        {{arraydataservice.amount}}
                    </span>
                </div>
                <div class="J-list-price-plus"  v-if="!view">
                    <button class="J-card-item-btn" @click="amountUnique(+1,index)"><i class="fas fa-plus"></i></button>
                </div>
            </div>
            <div v-if="view">
                <span>
                    {{view?`Cantidad total ${arraydataservice.amount}`:arraydataservice.amount}}
                </span>
            </div>
            <div v-if="view">
                <span>
                    {{`Total S/. ${arraydataservice.subtotal}`}}
                </span>
            </div>
        </div>
    </main>
</template>
<script>
    export default {
        data:()=>({
            dataSize:[
                {
                    size:"XS",
                    active:true,
                },
                {
                    size:"S",
                    active:false,

                },
                {
                    size:"M",
                    active:false,

                },
            ],
            arraydataservices:[],

        }),
        created(){
            var _this=this;
            this.arraydataservices=this.dataservices
            this.arraydataservices.forEach((el,index)=>{

                _this.$set(el,'color_image','')
                _this.$set(el,'color','')
                _this.$set(el,'sizes','')
                _this.$set(el,'color_index','')
                _this.$set(el,'color_price','')
                _this.$set(el,'color_description','')
                _this.$set(el,'color_stock','')
                _this.selectedColor(el.items[0],el,0)

                _this.activeSize(el.items[0].sizes[0],el)
            })
        },
        computed:{
            
        },
        methods:{
            calcDiscounts(price,percentaje){
                var price_new=price-((price*percentaje)/100)
                return price_new;
            },
            visualImg(data){
                this.$emit('viewImage',data)
            },
            activeSize(item,data){
               this.$set(data,'size',item)
            },
            amountUnique: async function(sum,index){

                var aux=this.arraydataservices[index]
             
                let result=(aux.items[aux.color_index]?aux.items[aux.color_index].amount:0||0)+sum;
                if(result<0) return;
                result=aux.size.amount+sum;
                if(result<0) return;
                aux.size.amount=result
                
                var data={
                    sum,
                    index,
                    i:aux.color_index
                }
                this.$emit('action','type',data)
            },
            selectedColor:async function(item,arraydataservice,i){
                try{
                   
                arraydataservice.color_image=item.images[0]!=null?item.images[0].link:''

                var sizes=[]

                for (let ind = 0; ind <  item.sizes.length; ind++) {
                    var obj={}
                    var el =  item.sizes[ind];
                    if(typeof el=='object'){
                        obj.size=el.size
                        obj.amount=el.amount
                        console.log(el.amount)
                    }
                    else{
                        obj.size=el
                        obj.amount=0
                    }

                    item.sizes[ind]=obj
                    sizes.push(obj)
                }
                console.log("=======>",i)

                arraydataservice.sizes=sizes
                arraydataservice.color_index=i
                arraydataservice.color_price=item.price
                arraydataservice.color_description=item.description
                arraydataservice.color_stock=item.stock

                 this.activeSize(item.sizes[0],arraydataservice)
            }
            catch($e){
                console.log($e)
            }
            }
        },
        props:{
            dataservices: [],
            view:false,
        },
        watch:{
            dataservices(){
                var _this=this;
                console.log("as jska ")
                this.arraydataservices=this.dataservices
                this.arraydataservices.forEach((el,index)=>{

                    _this.$set(el,'color_image','')
                    _this.$set(el,'color','')
                    _this.$set(el,'sizes','')
                    _this.$set(el,'color_index','')
                    _this.$set(el,'color_price','')
                    _this.$set(el,'color_description','')
                    _this.$set(el,'color_stock','')
                    _this.selectedColor(el.items[0],el,0)

                    _this.activeSize(el.items[0].sizes[0],el)
                })
            }
        }
    }
</script>